import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const clearInvoicingDiagnostics = () =>
  call(websocketFetch, 'clear_invoicing_diagnostics', {});
